// Parametry linku ekranu TV: results.sledzgps.pl/tv/{alias}?litery=…&przewijanie=…&nazwisko=…&trasy=…
// Czysta logika (bez Vue). Nieznana albo pusta wartość = domyślna, więc zły link nie psuje ekranu.

// Wielkość liter = ile wierszy mieści jedna kolumna (wysokość wiersza liczona z wysokości ekranu)
export const ROWS_BY_SIZE = Object.freeze({ daleko: 20, srednio: 25, blisko: 32 })
export const DEFAULT_SIZE = 'srednio'
export const MAX_ROUTES = 6

const OFF = ['0', 'nie', 'false', 'off']
const ALIAS = /^[A-Za-z0-9_-]{1,80}$/

function first(value) {
  return Array.isArray(value) ? value[0] : value
}

function text(value) {
  const v = first(value)
  return v == null ? '' : String(v).trim().toLowerCase()
}

// Alias trafia do adresu API — tylko litery, cyfry, „-” i „_”.
export function isValidAlias(alias) {
  return ALIAS.test(String(alias || ''))
}

/**
 * @param {Object} query  route.query
 * @param {string} alias  alias z adresu (pierwsza trasa)
 * @returns {{ size, rows, scroll: 'pages'|'smooth', surnameFirst, aliases: string[] }}
 */
export function parseTvParams(query = {}, alias = '') {
  const size = text(query.litery)
  const scroll = text(query.przewijanie)
  const extra = String(first(query.trasy) || '')
    .split(',')
    .map(a => a.trim())
    .filter(isValidAlias)
  const aliases = [String(alias || ''), ...extra]
    .filter((a, i, list) => isValidAlias(a) && list.indexOf(a) === i)
    .slice(0, MAX_ROUTES)
  const sizeKey = ROWS_BY_SIZE[size] ? size : DEFAULT_SIZE
  return {
    size: sizeKey,
    rows: ROWS_BY_SIZE[sizeKey],
    scroll: scroll === 'plynnie' || scroll === 'płynnie' ? 'smooth' : 'pages',
    surnameFirst: !OFF.includes(text(query.nazwisko)),
    aliases
  }
}
